import DocumentsContainer from './DocumentsContainer'

function DocumentsScreen() {
    return <DocumentsContainer />
}

export default DocumentsScreen
